import {createContext} from 'react';

 export const ThemingContext = createContext()

    




